import { CommonConstants } from './../utilities/commonConstants';
import { Injectable } from '@angular/core';
import { RouteContextProvider } from '../services/routeContextProvider.service';
import { Formatter } from './../services/formatter';
const TaskKeyArray = {
    offersalaried: CommonConstants.Routes.OfferSalaried,
    resumeapplication: CommonConstants.Routes.ResumeApplication,
    existingcustomer: CommonConstants.Routes.ExistingCustomer,
    esignotp:CommonConstants.Routes.EsignOtp,
    esignthankyou:CommonConstants.Routes.EsignThankYou,
};
@Injectable({
    providedIn: 'root'
})
export class RouteHandlerService {
    public Route: string = null;
    public NextTaskKey: string = null;
    public ExceptionKeyArr: any[];
    private taskKeyArray = TaskKeyArray;
    constructor(
        private _routeContextProvider: RouteContextProvider,
        private _formatter: Formatter
    ) { }
    public RouteToNextTask(nextTaskKey: string, exceptionKeysArr?: any, callback?: any) {
        this.Route = this.fetchRouteFromNextakKey(nextTaskKey);
        if (exceptionKeysArr && exceptionKeysArr.length > 0 && callback) {
            this.checkExceptionKeys(exceptionKeysArr, callback);
        } else if (callback) {
            callback(this.Route);
        } else if (this.Route) {
            this._routeContextProvider.NavigateToView([this.Route]);
        } else {
            console.error('ERROR:: Route not available.');
        }
    }
    private fetchRouteFromNextakKey(nextTaskKey: string): string {
        this.NextTaskKey = this._formatter.toSmallCase(nextTaskKey);
        return this.taskKeyArray[this.NextTaskKey] || '';
    }
    private checkExceptionKeys(exceptionKeysArr, callback: any) {
        let toRoute = false;
        this.ExceptionKeyArr = exceptionKeysArr;
        for (let key of this.ExceptionKeyArr) {
            key = this._formatter.toSmallCase(key);
            if (this.NextTaskKey === key) {
                toRoute = false;
                callback(this.Route);
                break;
            } else {
                toRoute = true;
            }
        }
        if (toRoute) {
            this._routeContextProvider.NavigateToView([this.Route]);
        }
    }
}
